export enum CONFIG_CAT_KEY {
    ENABLE_CACHED_STATS = 'enableCachedStats',
    FEATURE_DISCOVERY = 'featureDiscovery',
}
